import React , { Fragment }from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  canonical?: string;
  existingTitle?: string;
  recommendedTitle: string;
  metaDescription?: string;
  suggestedDesc?: string;
  suggestedH1?: string;
   parsedSchema?: Record<string, any>;
}

const SEO: React.FC<SEOProps> = ({
  canonical,
  existingTitle,
  recommendedTitle,
  metaDescription,
  suggestedDesc,
  suggestedH1,
  parsedSchema
}) => {

   const title = recommendedTitle || existingTitle;
   console.log(parsedSchema,"parsedSchema");
  return (
    <>
       <head>
       {/* ✅ Primary Title */}
        {title && <title>{title}</title>}
        {/* ✅ Meta Description */}
        {title && <meta name="title" content={title} />}

        {/* ✅ Meta Description */}
        {metaDescription && <meta name="description" content={metaDescription} />}

        {/* ✅ Secondary Meta (Suggested Description) */}
        {suggestedDesc && <meta name="summary-description" content={suggestedDesc} />}
         
          {/* ✅ Secondary Meta (Suggested h1) */}
        {suggestedH1 && <meta name="summary-h1" content={suggestedH1} />}
       
        {/* ✅ Canonical URL */}
        {canonical && <link rel="canonical" href={`${canonical}`} />}

        {/* ✅ Open Graph */}
        {title && <meta property="og:title" content={title} />}
        {metaDescription && (
          <meta property="og:description" content={metaDescription} />
        )}
        {canonical && <meta property="og:url" content={`${canonical}`} />}
        <meta property="og:type" content="website" />

        {/* ✅ Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        {title && <meta name="twitter:title" content={title} />}
        {metaDescription && (
          <meta name="twitter:description" content={metaDescription} />
        )}

             {/* ✅ Structured Data (JSON-LD) */}
            {parsedSchema && (
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify(parsedSchema),
                }}
              />
            )}
      </head>
      <body>
         {suggestedH1 &&<h1 style={{ color: "white", opacity: 0,position: "absolute" }}>{suggestedH1}</h1>}

      </body> 
      </>
  );
};

export default SEO;